"use strict";

define(['app'], function (app) {
  return app.Marionette.ItemView.extend({
    template: false,
    initialize: function initialize(options) {
      if (options.isGuest) {
        app.events.commands.execute('modal:login:show');
      }
    }
  });
});